import React from 'react';
import { Alert, Box, Button, Link, Stack, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTranslation } from 'react-i18next';
import { NS, PROFILE_KEYS } from '../../../i18n/constants/keys';
import { toast } from '../../../ui/toast';
import { ComingSoonOverlay, SectionCard } from '../../../ui/mui';

export const PrivacySection = () => {
  const { t } = useTranslation(NS.profile);

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <SectionCard
        title={t(PROFILE_KEYS.sections.privacy.title)}
        subtitle={t(PROFILE_KEYS.sections.privacy.intro)}
      >
        <Stack spacing={2.5}>
          <Alert severity="info">
            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>
              {t(PROFILE_KEYS.sections.privacy.policyTitle)}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1.5 }}>
              {t(PROFILE_KEYS.sections.privacy.policyDescription)}
            </Typography>
            <Link
              href="https://www.hiacuity.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, fontWeight: 600, fontSize: '0.8125rem' }}
            >
              {t(PROFILE_KEYS.sections.privacy.readPolicy)}
              <OpenInNewIcon fontSize="small" />
            </Link>
          </Alert>

          <ComingSoonOverlay label={t(PROFILE_KEYS.actions.comingSoon)}>
            <SectionCard title={t(PROFILE_KEYS.sections.privacy.dataManagement)}>
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between">
                  <Box>
                    <Typography variant="body1" fontWeight={600}>
                      {t(PROFILE_KEYS.sections.privacy.downloadData)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t(PROFILE_KEYS.sections.privacy.downloadDataDesc)}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    onClick={() => toast.info(t(PROFILE_KEYS.messages.dataDownloadRequested))}
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    {t(PROFILE_KEYS.sections.privacy.requestDownload)}
                  </Button>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between">
                  <Box>
                    <Typography variant="body1" fontWeight={600}>
                      {t(PROFILE_KEYS.sections.privacy.deleteAccount)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t(PROFILE_KEYS.sections.privacy.deleteAccountDesc)}
                    </Typography>
                  </Box>
                  <Button variant="contained" color="error" tabIndex={-1} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                    {t(PROFILE_KEYS.sections.privacy.deleteAccount)}
                  </Button>
                </Stack>
              </Stack>
            </SectionCard>
          </ComingSoonOverlay>
        </Stack>
      </SectionCard>
    </Box>
  );
};
